import {all, fork} from 'redux-saga/effects';
import authSaga from './authSaga';
import userSaga from './userSaga';
import analyticsSaga from './analyticsSaga';
import additionalHealthSaga from './additionalHealthSaga';
import beneficiariesSaga from './beneficiariesSaga';

export default function* rootSaga() {
    yield all([
        fork(authSaga),
        fork(userSaga),
        fork(additionalHealthSaga),
        fork(beneficiariesSaga),
        fork(analyticsSaga),
    ]);
}
